import { __extends } from "tslib";
import { TinyYolov2Options } from '../tinyYolov2';
var TinyFaceDetectorOptions = /** @class */ (function (_super) {
    __extends(TinyFaceDetectorOptions, _super);
    function TinyFaceDetectorOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._name = 'TinyFaceDetectorOptions';
        return _this;
    }
    return TinyFaceDetectorOptions;
}(TinyYolov2Options));
export { TinyFaceDetectorOptions };
//# sourceMappingURL=TinyFaceDetectorOptions.js.map